jQuery(document).ready(function () {

    // Recharge widget selection
    jQuery(document).on('click', '.first-button', function () {
    const widget = document.querySelector('recharge-subscription-widget');
    let oneTimeOption;

    if (widget && widget.shadowRoot) {
        oneTimeOption = widget.shadowRoot.querySelector('input[value="onetime"]');
    } else {
        oneTimeOption = jQuery('input[value="onetime"]')[0]; // get the DOM element from jQuery
    }

    if (oneTimeOption) oneTimeOption.click();

    jQuery(".product .months-wrap").hide();
    jQuery(".price.once-price").show();
    jQuery(".price.subscription-price").hide();
    jQuery("div.pricing-container div.pricing-option:first-child p.discount").hide();
    jQuery(".onetime-dicount").show();
    jQuery(".subsribe-dicount").hide();
    jQuery("p.discount.onetime-dicount").show();

    jQuery("p.discount.for-mobile").attr("style", "display: none !important;");
    jQuery("p.price.subscription-mobile").hide();
    jQuery("p.price.one-time-mobile").show();
    jQuery(".for-mobile .price.once-price").show();
    jQuery("p.price.for-mobile-subs").hide();
    jQuery(".for-mobile p.save-price").hide();
    jQuery(".for-mobile .subscription-discounyt-first").hide();
    jQuery(".subscription-heading").text("One-Time Purchase");

jQuery(".pricing-container div#option1").click();
    
    
});

jQuery(document).on('click', '.second-button', function () {
    const widget = document.querySelector('recharge-subscription-widget');
    let subscriptionOption;

    if (widget && widget.shadowRoot) {
        subscriptionOption = widget.shadowRoot.querySelector('input[value="subscription"]');
    } else {
        subscriptionOption = jQuery('input[value="subscription"]')[0];
    }

    if (subscriptionOption) subscriptionOption.click();

    jQuery(".product .months-wrap").show();
    jQuery(".price.once-price").hide();
    jQuery(".price.subscription-price").show();
    jQuery("div.pricing-container div.pricing-option:first-child p.discount").show();
    jQuery(".onetime-dicount").hide();
    jQuery(".subsribe-dicount").show();
    jQuery("p.discount.onetime-dicount").hide();
    jQuery("p.price.subscription-mobile").show();
    jQuery("p.discount.for-mobile").show();
    jQuery("p.price.one-time-mobile").hide();
    jQuery(".for-mobile .price.once-price").hide();
    jQuery("p.price.for-mobile-subs").show();
    jQuery(".for-mobile p.save-price").show();
    jQuery(".for-mobile .subscription-discounyt-first").show();
    jQuery(".subscription-heading").text("Subscribe & Save");
    jQuery(".pricing-container div#option1").click();
    
});


    

    // Variation click price change
    setTimeout(function () {
        // jQuery(".pricing-container div:first-child").click();
        jQuery(".pricing-container div:nth-child(2)").click();
    }, 1000); // 2 second delay
    jQuery(document).on('click', '.pricing-container div#option1', function () {
        jQuery(".quantity__input").val(1);
    });
    jQuery(document).on('click', '.pricing-container div#option2', function () {
        jQuery(".quantity__input").val(2);
    });
    jQuery(document).on('click', '.pricing-container div#option3', function () {
        jQuery(".quantity__input").val(3);
    });

    // Variation price add class
    $(document).ready(function () {
        $(".pricing-option").click(function () {
            $(".pricing-option").removeClass("active");
            $(this).addClass("active");
        });
    });






    $(".first-sec").addClass("active");
    // $(".sec-sec").addClass("active");

    $(".first-sec, .sec-sec, .third-sec").on("click", function () {
        $(".first-sec, .sec-sec, .third-sec").removeClass("active");
        $(this).addClass("active");
    });


    jQuery(document).on('click', '.first-div.first-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="1 month save 20%"]');
        oneTimeOption1.click();
    })

    jQuery(document).on('click', '.first-div.sec-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="2 months save 20%"]');
        oneTimeOption1.click();
    })

    jQuery(document).on('click', '.first-div.third-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="3 months save 20%"]');
        oneTimeOption1.click();
    })



    jQuery(document).ready(function () {
    setTimeout(function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="1 month save 20%"]');
        oneTimeOption1.click();
    }, 1500);

});


    jQuery('ul.footer-block__details-content a.link').on('click', function () {
        jQuery(this).toggleClass('active');
    });


    // Scroll click on subscribe and scoll
    jQuery(document).on("click", ".why-subscribe-section a.cta-button, .common-buy-now", function (e) {
        e.preventDefault();

        jQuery("html, body").animate({
            scrollTop: 190
        }, 700);
    });


    function scrollWithOffset() {
        if (window.location.hash === '#subscribe-section') {

            var target = $('#subscribe-section');

            if (target.length) {
                var offset = target.offset().top - 400;


                $('html, body').stop().animate({
                    scrollTop: 190
                }, 700);
            }
        }
    }


    if (window.location.hash) {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 1);
    }

    setTimeout(scrollWithOffset, 600);


$(".offer-btn").each(function(){
    $(this).click(function(){
$(this).addClass('active');    
        $(this).siblings().removeClass('active');
        
    });

});
jQuery(document).ready(function ($) {

  $('.faq-item').removeClass('active').prop('open', false);

  $(document).on('click', '.faq-question', function (e) {
    e.preventDefault();

    const $details = $(this).closest('.faq-item');
    const isOpen = $details.prop('open');

    $('.faq-item').removeClass('active').prop('open', false);
    $('.faq-icon').text('+');

    if (!isOpen) {
      $details.addClass('active').prop('open', true);
      $(this).find('.faq-icon').text('-');
    }
  });

});


const offerTextLine = $('.content-wrapper p.offer-text').next('p');

// When "Buy once" clicked
$('.first-button').on('click', function(){
  $('.first-button').addClass('active');
  $('.second-button').removeClass('active');

  // Existing text updates
  $('.longevity-offer-buttons .left-btn .main-text').text('Just £6.99');
  $('.longevity-offer-buttons .left-btn .sub-text').text('Usually £34.99');
  $('.longevity-offer-buttons .right-btn').text("I Don’t Need It");
  $('.longevity-offer-box h3').html('<b>Add The Real Life Longevity Framework Book?</b>');

  // Show offer line again
  offerTextLine.show();
});

// When "Subscribe & Save" clicked
$('.second-button').on('click', function(){
  $('.second-button').addClass('active');
  $('.first-button').removeClass('active');

  // Existing text updates
  $('.longevity-offer-buttons .left-btn .main-text').text('Free For Subscribers');
  $('.longevity-offer-buttons .left-btn .sub-text').text('Normally £34.99');
  $('.longevity-offer-buttons .right-btn').text("I Don’t Want The Free Book");
  $('.longevity-offer-box h3').html('<b>Supplements Work Better With A Framework</b>');

  // Hide only this line
  offerTextLine.hide();
});

}); 

function resetOfferSelection() {
  jQuery('.longevity-offer-buttons .offer-btn').removeClass('active');
}


/* =====================================================
   BUY ONCE / SUBSCRIBE TOGGLE
===================================================== */
const $firstBtn  = jQuery('.first-button');   // Buy once
const $secondBtn = jQuery('.second-button');  // Subscribe

function resetOfferSelection() {
  jQuery('.longevity-offer-buttons .offer-btn').removeClass('active');
}

/* ===== NEW FUNCTION ADDED ===== */
function syncBookWithPlan() {
  const $offerLeft  = jQuery('.offer-btn.left-btn');
  const $offerRight = jQuery('.offer-btn.right-btn');

  resetOfferSelection();

  // If Subscribe active → Select LEFT (Book)
  if ($secondBtn.hasClass('active')) {
    $offerLeft.addClass('active');
  }

  // If Buy Once active → Select RIGHT (No Book)
  if ($firstBtn.hasClass('active')) {
    $offerRight.addClass('active');
  }
}

// Buy once
$firstBtn.on('click', function () {
  jQuery(this).addClass('active');
  $secondBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});

// Subscribe
$secondBtn.on('click', function () {
  jQuery(this).addClass('active');
  $firstBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});

// Default: Subscribe active
jQuery(document).ready(function () {
  $secondBtn.addClass('active');
  $firstBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});




jQuery(document).ready(function($) {
  $('.book-price-card').removeClass('active');
  $('.book-price-card').first().addClass('active');
  $('.book-price-card').on('click', function() {
    $('.book-price-card').removeClass('active');
    $(this).addClass('active');
  });




  jQuery(document).on('change', ".delivery-frequency-select", function () {
    var value = jQuery(this).val();
     var valuetext = jQuery(this).find("option:selected").text().trim();
    console.log(valuetext);
    if (valuetext == "Every Month Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="1 month"]');
        oneTimeOption1.click();

    }


    if (valuetext == "Every 2 Months Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="2 months"]');
        oneTimeOption1.click();

    }

    if (valuetext == "Every 3 Months Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="3 months"]');
        oneTimeOption1.click();

    }


    if (valuetext == "Every 4 Months Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="4 months"]');
        oneTimeOption1.click();

    }


    if (valuetext == "Every 5 Months Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="5 months"]');
        oneTimeOption1.click();

    }


    if (valuetext == "Every 6 Months Subscription") {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="6 months"]');
        oneTimeOption1.click();

    }


})

   setTimeout(function() {
jQuery(".delivery-frequency-select").change();
}, 1000); 

jQuery('.product-form button[name="add"]').click(function(){
    var valqty = jQuery('input.quantity__input').val();
    localStorage.setItem('localqty', valqty);

    

    setTimeout(function() {
    let localqty = localStorage.getItem('localqty');
        jQuery('input.quantity__input').val(localqty);
}, 2500); // Displays alert after 2 seconds
    
    

})

});





// jQuery(document).ready(function ($) {
//     const $firstBtn  = $('.first-button');
//     const $secondBtn = $('.second-button');
//     function setSellingPlan(value) {
//         $('form[action^="/cart/add"]').each(function () {   
//             let input = $(this).find('input[name="selling_plan"]');
//             if (input.length) input.val(value);
//         });
//     }
//     function selectOption(option) {
//         $('.pricing-option').removeClass('active');
//         $('#option' + option).addClass('active');
//         $('.quantity__input').val(option);
//     }
//     $(document).on('click', '.switch-to-one-time-purchase a', function(e){
//         e.preventDefault();
//     });
//     $(document).on('click', '.first-button', function () {

//         $firstBtn.addClass('active');
//         $secondBtn.removeClass('active');

//         setSellingPlan('');
//         $('.months-wrap').hide();

//         // Always 3 bottles
//         setTimeout(function () {
//             selectOption(3);
//         }, 1);
//     });

//     /* SUBSCRIBE */
//     $(document).on('click', '.second-button', function () {

//         $secondBtn.addClass('active');
//         $firstBtn.removeClass('active');
//         $('.months-wrap').show();
//         setTimeout(function () {
//             $('.delivery-frequency-select').trigger('change');
//             setTimeout(function () {
//                 selectOption(2);
//             }, 250);
//         }, 150);
//     });

//     /*  SWITCH BUTTONS */
//     $(document).on('click', '.switch-one-time a', function(e){
//         e.preventDefault();
//         $firstBtn.trigger('click');
//     });

//     $(document).on('click', '.swich-to-subscribe-Save a', function(e){
//         e.preventDefault();
//         $secondBtn.trigger('click');
//     });

//     /* =========================
//        DROPDOWN CHANGE
//     ========================= */
//     $(document).on('change', '.delivery-frequency-select', function () {
//         if ($secondBtn.hasClass('active')) {
//             setSellingPlan($(this).val());
//             setTimeout(function () {
//                 selectOption(2);
//             }, 200);
//         }
//     });

//     /* =========================
//        PRODUCT DEFAULT SET
//     ========================= */
//     const productTitle = $('.product__title h1').text().toLowerCase();

//     function initProduct(monthText, option) {

//         // Activate subscribe UI
//         $secondBtn.addClass('active');
//         $firstBtn.removeClass('active');
//         $('.months-wrap').show();

//         setTimeout(function () {

//             // Set correct frequency
//             $('.delivery-frequency-select option').each(function () {
//                 if ($(this).text().toLowerCase().includes(monthText)) {
//                     $(this).prop('selected', true);
//                 }
//             });
//             $('.delivery-frequency-select').trigger('change');

//             setTimeout(function () {
//                 selectOption(option);
//             }, 300);

//         }, 800); // wait for recharge load
//     }

//     // NMN / Resveratrol / Collagen
//     if (
//         productTitle.includes('nmn') ||
//         productTitle.includes('resveratrol') ||
//         productTitle.includes('collagen')
//     ) {
//         initProduct('4 months', 2);
//     }

//     // Throx
//     if (
//         productTitle.includes('throx') ||
//         productTitle.includes('thyrox')
//     ) {
//         initProduct('2 months', 2);
//     }

// });

// jQuery(document).ready(function ($) {

//     const $firstBtn  = $('.first-button');
//     const $secondBtn = $('.second-button');

//     function setSellingPlan(value) {
//         $('form[action^="/cart/add"]').each(function () {   
//             let input = $(this).find('input[name="selling_plan"]');
//             if (input.length) input.val(value);
//         });
//     }

//     function selectOption(option) {
//         $('.pricing-option').removeClass('active');
//         $('#option' + option).addClass('active');
//         $('.quantity__input').val(option);
//     }

//     // ✅ NEW FUNCTION (important fix)
//     function getCurrentOption() {
//         let active = $('.pricing-option.active').attr('id');
//         return active ? active.replace('option', '') : 1;
//     }

//     $(document).on('click', '.switch-to-one-time-purchase a', function(e){
//         e.preventDefault();
//     });

//     $(document).on('click', '.first-button', function () {

//         $firstBtn.addClass('active');
//         $secondBtn.removeClass('active');

//         setSellingPlan('');
//         $('.months-wrap').hide();

//         // Always 3 bottles
//         setTimeout(function () {
//             selectOption(3);
//         }, 1);
//     });

//     /* SUBSCRIBE */
//     $(document).on('click', '.second-button', function () {

//         $secondBtn.addClass('active');
//         $firstBtn.removeClass('active');
//         $('.months-wrap').show();

//         setTimeout(function () {
//             $('.delivery-frequency-select').trigger('change');

//             setTimeout(function () {
//                 selectOption(getCurrentOption()); // ✅ FIX
//             }, 250);

//         }, 150);
//     });

//     /*  SWITCH BUTTONS */
//     $(document).on('click', '.switch-one-time a', function(e){
//         e.preventDefault();
//         $firstBtn.trigger('click');
//     });

//     $(document).on('click', '.swich-to-subscribe-Save a', function(e){
//         e.preventDefault();
//         $secondBtn.trigger('click');
//     });

//     /* =========================
//        DROPDOWN CHANGE
//     ========================= */
//     $(document).on('change', '.delivery-frequency-select', function () {
//         if ($secondBtn.hasClass('active')) {
//             setSellingPlan($(this).val());

//             setTimeout(function () {
//                 selectOption(getCurrentOption()); // ✅ FIX
//             }, 200);
//         }
//     });

//     /* =========================
//        PRODUCT DEFAULT SET
//     ========================= */
//     const productTitle = $('.product__title h1').text().toLowerCase();

//     function initProduct(monthText, option) {

//         // Activate subscribe UI
//         $secondBtn.addClass('active');
//         $firstBtn.removeClass('active');
//         $('.months-wrap').show();

//         setTimeout(function () {

//             // Set correct frequency
//             $('.delivery-frequency-select option').each(function () {
//                 if ($(this).text().toLowerCase().includes(monthText)) {
//                     $(this).prop('selected', true);
//                 }
//             });

//             $('.delivery-frequency-select').trigger('change');

//             setTimeout(function () {
//                 selectOption(option);
//             }, 300);

//         }, 800);
//     }

//     // NMN / Resveratrol / Collagen
//     if (
//         productTitle.includes('nmn') ||
//         productTitle.includes('resveratrol') ||
//         productTitle.includes('collagen')
//     ) {
//         initProduct('4 months', 2);
//     }

//     // Throx
//     if (
//         productTitle.includes('throx') ||
//         productTitle.includes('thyrox')
//     ) {
//         initProduct('2 months', 2);
//     }

// });

jQuery(document).ready(function ($) {

    const $firstBtn  = $('.first-button');
    const $secondBtn = $('.second-button');

    // ✅ NEW FLAG
    let isSwitchClick = false;

    function setSellingPlan(value) {
        $('form[action^="/cart/add"]').each(function () {   
            let input = $(this).find('input[name="selling_plan"]');
            if (input.length) input.val(value);
        });
    }

    function selectOption(option) {
        $('.pricing-option').removeClass('active');
        $('#option' + option).addClass('active');
        $('.quantity__input').val(option);
    }

    function getCurrentOption() {
        let active = $('.pricing-option.active').attr('id');
        return active ? active.replace('option', '') : 1;
    }

    $(document).on('click', '.switch-to-one-time-purchase a', function(e){
        e.preventDefault();
    });

    $(document).on('click', '.first-button', function () {

        $firstBtn.addClass('active');
        $secondBtn.removeClass('active');

        setSellingPlan('');
        $('.months-wrap').hide();

        setTimeout(function () {
            selectOption(3);
        }, 1);
    });

    /* SUBSCRIBE */
    $(document).on('click', '.second-button', function () {

        $secondBtn.addClass('active');
        $firstBtn.removeClass('active');
        $('.months-wrap').show();

        setTimeout(function () {
            $('.delivery-frequency-select').trigger('change');

            setTimeout(function () {

                // ✅ FIX HERE
                if (isSwitchClick) {
                    selectOption(2); // force 2 on switch
                    isSwitchClick = false;
                } else {
                    selectOption(getCurrentOption());
                }

            }, 250);

        }, 150);
    });

    /*  SWITCH BUTTONS */
    $(document).on('click', '.switch-one-time a', function(e){
        e.preventDefault();
        $firstBtn.trigger('click');
    });

    $(document).on('click', '.swich-to-subscribe-Save a', function(e){
        e.preventDefault();

        isSwitchClick = true; // ✅ IMPORTANT FIX
        $secondBtn.trigger('click');
    });

    /* =========================
       DROPDOWN CHANGE
    ========================= */
    $(document).on('change', '.delivery-frequency-select', function () {
        if ($secondBtn.hasClass('active')) {
            setSellingPlan($(this).val());

            setTimeout(function () {
                selectOption(getCurrentOption());
            }, 200);
        }
    });

    /* =========================
       PRODUCT DEFAULT SET
    ========================= */
    const productTitle = $('.product__title h1').text().toLowerCase();

    function initProduct(monthText, option) {

        $secondBtn.addClass('active');
        $firstBtn.removeClass('active');
        $('.months-wrap').show();

        setTimeout(function () {

            $('.delivery-frequency-select option').each(function () {
                if ($(this).text().toLowerCase().includes(monthText)) {
                    $(this).prop('selected', true);
                }
            });

            $('.delivery-frequency-select').trigger('change');

            setTimeout(function () {
                selectOption(option);
            }, 300);

        }, 800);
    }

    if (
        productTitle.includes('nmn') ||
        productTitle.includes('resveratrol') ||
        productTitle.includes('collagen')
    ) {
        initProduct('4 months', 2);
    }

    if (
        productTitle.includes('throx') ||
        productTitle.includes('thyrox')
    ) {
        initProduct('2 months', 2);
    }

});



jQuery(document).ready(function ($) {

    if ($('body').hasClass('3-in-1-magnesium-template')) {

        $('.pricing-option').removeClass('active');
        $('#option2').addClass('active');

    }

});



